import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core'
import { CpmService } from '../../../service/cpm.service'
import { StoreService } from '../../../service/store.service'
import { Subscription } from 'rxjs/Subscription'
import { ActivatedRoute } from '@angular/router'
import { environment } from '../../../../environments/environment'
import { SummaryComponent } from '../summary/summary.component'
import { ExportExcelService } from '../../../service/export-excel.service'
import { TransactionComponent } from '../transaction/transaction.component'
import { AuthorizeService } from '../../../service/authorize.service'
@Component({
  selector: 'app-corporate-screen',
  templateUrl: './corporate-screen.component.html',
  styleUrls: ['./corporate-screen.component.scss']
})
export class CorporateScreenComponent implements OnInit, AfterViewInit {
  @ViewChild(TransactionComponent) tranSaction: TransactionComponent
  @ViewChild(SummaryComponent) summaryView: SummaryComponent
  subscription: Subscription
  print = false
  pdf = false
  displayHeader = true
  displayComponent = false
  symbol
  getPrint
  printFirst = true
  printPage = false

  constructor(
    private cpmService: CpmService,
    private excelService: ExportExcelService,
    private store: StoreService,
    private activatedRoute: ActivatedRoute,
    private authorization: AuthorizeService
  ) { }

  ngOnInit() {
    const { symbol } = this.activatedRoute.snapshot.params
    const { pdf, print } = this.activatedRoute.snapshot.data
    this.getPrint = print

    pdf === undefined ? (this.pdf = false) : (this.pdf = pdf)
    print === undefined ? (this.print = false) : (this.print = print)

    if (symbol) {
      this.cpmService.getSecurityProfileNew(symbol)
    }

    this.store.getSecurityProfileNewResultObservable().subscribe(response => {
      if (!response) {
        return
      }
      this.symbol = response['securitySymbol']
      if (this.symbol !== '') {
        this.displayComponent = true
      } else {
        this.displayComponent = false
      }
    })

    if (this.print || this.pdf) {
      this.displayHeader = true
      this.printPage = true
    } else {
      this.displayHeader = false
      this.printPage = false
    }
  }

  get isUserHasPermission(): Boolean {
    return this.authorization.hasRole('ROLE_USER')
  }

  exportPrint = function (symbol) {
    return function corporatePrint() {
      const endcodeSymbol = encodeURIComponent(symbol)
      const popupWin = window.open(
        `/#/corporate/${endcodeSymbol}`,
        '_blank',
        'width=850px,height=1024px'
      )
    }
  }

  exportPdf = function (symbol) {
    const service = this.cpmService
    return function corporatePdf() {
      const endcodeSymbol = encodeURIComponent(symbol)
      service.downloadFile(
        `${environment.cpmBaseUrl}/pdf/corporate?symbol=${endcodeSymbol}`
      )
    }
  }

  exportEmail = function (symbol, service) {
    return function mailCorporate() {
      const endcodeSymbol = encodeURIComponent(symbol)
      service.saveCorporatePdfFile(endcodeSymbol).then(filename => {
        const subject = 'Corporate-Action'
        const downloadUrl = encodeURIComponent(
          `${environment.cpmBaseUrl}/download?type=report&filename=${filename}`
        )
        window.location.href = `mailto:?subject=${subject}&body=${downloadUrl}`
      })
    }
  }

  exportExcel(service, transaction, summary) {
    return function excelCorporate() {
      // service.exportExcelSummary(summary.excelSummary, 'Summary Excel')
      // service.exportExcelTransaction(transaction.listTable, 'Transaction Excel', transaction.tradingDate)
      const data = {
        sheet_name: ['Summary', 'Transaction'],
        ws_data: [
          !!summary.ws_data_toExcel ? summary.ws_data_toExcel : null
          , !!transaction.ws_data_toExcel ? transaction.ws_data_toExcel : null]

      }
      service.exportExcelCA(data)
    }
  }

  refreshScreen(event) {
    this.summaryView.onChangeData()
  }

  exportFunctions() {
    const arrayOfFunctions: Map<String, Function> = new Map<String, Function>()
    arrayOfFunctions.set(
      'email',
      this.exportEmail(this.symbol, this.cpmService)
    )
    arrayOfFunctions.set('print', this.exportPrint(this.symbol))
    arrayOfFunctions.set('pdf', this.exportPdf(this.symbol))
    arrayOfFunctions.set('excel', this.exportExcel(this.excelService, this.tranSaction, this.summaryView))
    return arrayOfFunctions
  }

  ngAfterViewInit() {
    if (this.getPrint) {
      window.setTimeout('window.print()', 5000);
    }
  }

}



// WEBPACK FOOTER //
// /opt/alm/jenkins/workspace/mis-cpm/mis-cpm-prod-front/src/app/securities-level/corporate-action/corporate-screen/corporate-screen.component.ts